// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"terminal-rectangle-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 20H22V9H2V20Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M2 4H22V9H2V4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 9H2M22 9V20H2V9M22 9V4H2V9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 12.5L9 14.5L7 16.5M13 16L17 16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TerminalRectangle1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'terminal-rectangle-1',
    ref,
    icon: element,
  },
));

TerminalRectangle1Icon.displayName = 'TerminalRectangle1Icon';

export default TerminalRectangle1Icon;
